// extracted by mini-css-extract-plugin
export var growableInput = "_9n-0";
export var tagContainer = "_9n-2";
export var textInput = "_9n-1";